import Responsive from './Responsive';
const r = new Responsive();
module.exports = function() {
	const line = $('.card_mg_introduction-line');
	let length_px = 0;

	$(window).on('load resize',function(){
		length_px = 0;
		if(r.state()()){
			$('.card_mg_introduction-part').each(function(){
				length_px = length_px + $(this).outerWidth();
			});

			line.css({'width':length_px,'height':1});
		}else{

			length_px = length_px + $('.card_mg_introduction-inner').outerHeight() + 50;

			line.css({'width':1,'height':length_px});
		}
	});


	const line_mg_area = $('.js-mg_area-line');
	let length_px_mg_area = 0;

	$(window).on('load resize',function(){
		length_px_mg_area = 0;
		if(r.state()()){
			$('.js-mg_area').each(function(){
				length_px_mg_area = length_px_mg_area + $(this).outerHeight();
			});

			line_mg_area.css({'width':1,'height':length_px_mg_area});
		}
	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/mg_introduction.js